<template>
    <div class="data-container">
        <div class="tool-box">
            <el-button type="primary" :icon="Refresh" @click="getTableData">刷新</el-button>
            <el-button type="primary" plain :icon="Plus" @click="onAddClick()" v-permission="['base:dept:add']">添加</el-button>
            <el-button type="primary" plain :icon="Download" @click="importsVisible = true" v-permission="['base:dept:import']">
                导入
            </el-button>
            <el-button type="primary" plain :icon="Upload" @click="onExportClick('部门')" v-permission="['base:dept:export']">
                导出
            </el-button>
            <el-button type="primary" plain :icon="DCaret" @click="onSortClick(batchPatch)" v-permission="['base:dept:sort']">
                一键排序
            </el-button>
        </div>
        <el-table class="data-table" :data="table_data" v-loading="tableLoading" table-layout="auto">
            <el-table-column label="序号" type="index" width="60" />
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="status" label="状态">
                <template #default="{ row }">
                    <el-switch
                        v-model="row.status"
                        :active-value="1"
                        :inactive-value="0"
                        @change="(val) => handleStatus({ value: val, data: row, api: batchPatch })"
                        style="--el-switch-on-color: #13ce66"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间"></el-table-column>
            <el-table-column prop="list_order" label="排序">
                <template #default="scope">
                    <el-input-number
                        style="width: 100px"
                        type="number"
                        v-model="scope.row.list_order"
                        :min="0"
                        :max="999999"
                        controls-position="right"
                        size="small"
                    />
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="300">
                <template #default="{ row }">
                    <el-button type="primary" link :icon="Edit" @click="onEditClick(row)" v-permission="['base:dept:edit']">
                        编辑
                    </el-button>
                    <el-button
                        type="primary"
                        link
                        :icon="Delete"
                        @click="onRemoveClick({ data: row, api: delDepartment })"
                        v-permission="['base:dept:remove']"
                    >
                        删除
                    </el-button>
                    <el-button type="primary" link :icon="Plus" @click="onAddClick(row)" v-permission="['base:dept:edit']">
                        添加子节点
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <forms-dialog
            v-model="formDialogVisible"
            :isForm="isForm"
            :formId="deptId"
            :deptOptionLists="table_data || []"
            :parentId="parentId"
            @updateForm="getTableData"
        ></forms-dialog>
        <ImportsForm v-model="importsVisible" @updateForm="getTableData" menuCode="department" />
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import FormsDialog from './components/forms.vue'
import { batchPatch, getDepartmentTree } from '@/api/dept.js'
import ImportsForm from '@/components/ImportsForm.vue'
import { DCaret, Delete, Download, Edit, Plus, Refresh, Upload } from '@element-plus/icons'
import useTable from '@/hooks/useTable'

const { table_data, tableLoading, getTableData, onRemoveClick, onSortClick, onExportClick, handleStatus } = useTable(
    getDepartmentTree,
    {},
    { hasChildren: true, hasPagination: false }
)
onMounted(() => {
    getTableData()
})

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const deptId = ref('') // 点中的模块id
// 保证每次打开重新获取用户角色数据
watch(formDialogVisible, (val) => {
    if (!val) {
        deptId.value = ''
        parentId.value = ''
    }
})
// 编辑
const onEditClick = (row) => {
    deptId.value = row.id
    isForm.value = true
    formDialogVisible.value = true
}
const parentId = ref('')
// 添加
const onAddClick = (row) => {
    if (row) parentId.value = row.id
    deptId.value = ''
    isForm.value = true
    formDialogVisible.value = true
}

// 导入
const importsVisible = ref(false)
</script>

<style lang="scss" scoped></style>
